export const OFFSET = 50;
export const MIN_ITEMS_FOR_MOBILE_COLLAPSE = 3;
export const PARENT_PAGE_OFFSET = 2;
export const ELLIPSIS = '...';
